import { t } from '@/utils/i18n'
import { useState, useEffect } from 'react'
// import { useMount, } from 'ahooks'
import { common } from '@/utils'
import { Order } from '@/pages/Order/types'
import styles from './index.module.less'

const { getOrderStatusLabel } = common

interface IProps {
  order: Order
}

function OrderStatusLabel(props: IProps) {
  const { order } = props
  const [statusLabel, setStatusLabel] = useState('')
  const [className, setClassName] = useState('')

  useEffect(() => {
    const orderStatusLabel = getOrderStatusLabel(order)
    setStatusLabel(orderStatusLabel)
    if ([t('已作废'), t('退货关闭')].includes(orderStatusLabel)) {
      setClassName(styles['tag-cancel'])
    } else {
      setClassName(styles['tag-normal'])
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order])

  return (
    <div className={className}>
      <span>{statusLabel}</span>
    </div>
  )
}

export default OrderStatusLabel
